<div class="icon-container"><mat-icon class="completed-check" svgIcon="check"></mat-icon></div>
<h2 class="text">{{ data }}</h2>
